import { useDesignVersion } from '@fluentui-copilot/react-provider';
import { Badge, getIntrinsicElementProps, slot, useId } from '@fluentui/react-components';
import type { PromptStarterProps, PromptStarterState } from './PromptStarter.types';

/**
 * Create the state required to render PromptStarter.
 *
 * The returned state can be modified with hooks such as usePromptStarterStyles_unstable,
 * before being passed to renderPromptStarter_unstable.
 *
 * @deprecated Use PromptStarterV2 instead.
 * Deprecated on 10/21/2025
 *
 * @param props - props from this instance of PromptStarter
 * @param ref - reference to root HTMLElement of PromptStarter
 */
export const usePromptStarter_unstable = (
  props: PromptStarterProps,
  ref: React.Ref<HTMLButtonElement>,
): PromptStarterState => {
  const designVersion = useDesignVersion(props.designVersion);
  const idPrefix = useId('prompt-starter');

  return {
    components: {
      root: 'button',
      icon: 'span',
      category: 'span',
      prompt: 'span',
      badge: Badge,
    },
    root: slot.always(
      getIntrinsicElementProps('button', {
        ref,
        'aria-labelledby': `${idPrefix}-category`,
        'aria-describedby': `${idPrefix}-prompt`,
        ...props,
      }),
      { elementType: 'button' },
    ),
    icon: slot.always(props.icon, { elementType: 'span' }),
    category: slot.always(props.category, { defaultProps: { id: `${idPrefix}-category` }, elementType: 'span' }),
    prompt: slot.optional(props.prompt, { defaultProps: { id: `${idPrefix}-prompt` }, elementType: 'span' }),
    badge: slot.optional(props.badge, { defaultProps: { appearance: 'tint' }, elementType: Badge }),
    designVersion,
  };
};
